const Header = () => {
  return (
    <hgroup>
      <h2 className="main_header">Elisir Magazzino</h2>
    </hgroup>
  );
};
export default Header;
